<div class="swiper">
    <div
        class="swiper-container"
        [swiper]="swiperOptions"
        (slideChangeTransitionEnd)="handleTransitionEnd()"
    >
        <div class="swiper-wrapper">
            @for (screen of screens; track screen) {
            <div class="swiper-slide">
                <app-screen [resource]="screen"></app-screen>
            </div>
            }
        </div>
    </div>
</div>
